import React, { Component } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { animateScroll as scroll } from 'react-scroll';
import { isMobile } from 'react-device-detect';
import Repeatable from 'react-repeatable';
import { Helmet } from "react-helmet";

import Florest from '../Florest';
import FlorestChooseClass from '../FlorestChooseClass';
import BottomLayer from '../BottomLayer';
import Cave from '../Cave';
import Sea from '../Sea';
import Island from '../Island';

import UpdateLayerMovementSpeed from '../../hoc/UpdateLayerMovementSpeed';

import ContactForm from '../../components/ContactForm';
import TransitionBackground from '../../components/TransitionBackground';
import Loading from '../../components/Loading';

import './styles.css';

import CharChangeSheet from '../../assets/main/character-change-row.png';

import { charChangeConfigs } from '../../constants/spriteConfigs';
import imageSrcs from '../../constants/adventureImageSrcs';

class AdventureWorld extends Component {
  constructor(props) {
    super(props);

    this.prev = null;
    this.page = React.createRef();
    this.bottomLayer = React.createRef();

    this.state = {
      shouldAnim: true,
      move: '',
      mobileDirection: '',
      scrollPos: 0,
      charClass: '',
      isBlockScroll: false,
      isAssetsLoaded: false,
      isLoading: true,
      blockScroll: true,
      blockScrollMobile: true,
      charAttack: false,
      startAttack: false,
      shouldExplode: false,
      stopMove: false,
      sendEmail: false,
      stateSendEmail: '',
      resumeBottleAnim: false,
      message: '',
      firstCharMainLoaded: false,
      spriteFrame: '',
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener("orientationchange", this.handleOrientationChange);

    let counterImgLoad = 0;

    // eslint-disable-next-line no-unused-vars
    for (const url of imageSrcs) {
      const img = new Image();

      // eslint-disable-next-line no-loop-func
      img.onload = () => {
        counterImgLoad += 1;

        if (counterImgLoad === imageSrcs.length) {
          this.setState({ isAssetsLoaded: true });
        }
      };

      img.src = url;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    window.addEventListener("orientationchange", this.handleOrientationChange);
  }

  blockScroll = blockScroll => {
    if (isMobile) {
      this.setState({ blockScrollMobile: blockScroll, isBlockScroll: blockScroll });

      return;
    }

    this.setState({ blockScroll, isBlockScroll: blockScroll });
  }

  canAnim = () => {
    this.setState({ shouldAnim: true });
  };

  cantAnim = () => this.setState({ shouldAnim: false, move: '' });

  showCharAttackButton = () => this.setState({ charAttack: true });

  hideCharAttackButton = () => this.setState({ charAttack: false });

  changeCharClassAnim = charClass => {
    this.blockScroll(true);

    this.setState(
      {
        sprite: CharChangeSheet,
        spriteConfs: charChangeConfigs,
        charClass,
        move: 'right',
      },
      () => {
        this.cantAnim();
      },
    );
  };

  removeMessage = () => {
    this.setState({ message: '', spriteFrame: '0' }, () => this.blockScroll(false));
  }

  setMessage = newMessage => {
    const { message, queueMessage, charClass } = this.state;

    if (message === 'sayHey' && queueMessage === '') {
      this.setState({ queueMessage: newMessage });

      return;
    }

    this.setState({ queueMessage: '', message: newMessage, spriteFrame: `${charClass === '' ? '675' : '0'}` }, () => this.blockScroll(true));
  }

  setMobileDirection = direction => {
    const { blockScrollMobile } = this.state;

    if (!blockScrollMobile) {
      this.setState({ mobileDirection: direction }, () => window.dispatchEvent(new CustomEvent('scroll')));
    }
  }

  stopLoad = () => {
    const { firstCharMainLoaded } = this.state;

    if (!firstCharMainLoaded) {
      this.setState({ isLoading: false, firstCharMainLoaded: true }, () => {
        scroll.scrollToTop();

        const transitionPage = document.getElementsByClassName('container');
        this.blockScroll(false);

        transitionPage[0].addEventListener("transitionend", this.handleTransitionEnd);
        this.handleOrientationChange();
      });
    }
  }

  handleOrientationChange = () => {
    let orientation = 'portrait';
    // eslint-disable-next-line no-unused-vars
    let type = 'primary';
    const angle = 0;

    if (window.orientation) {
      orientation = Math.abs(angle) === 90 ? 'landscape' : 'portrait';
    }

    if (window.screen.orientation) {
      [orientation, type] = window.screen.orientation.type.split('-');
    }

    if (isMobile) {
      switch (orientation) {
        case 'landscape':
          this.setState({ screenOrientation: 'landscape' }, () => this.setMessage('landscape'));
          break;
        default:
          this.setState({ screenOrientation: 'portrait' }, () => this.removeMessage());
          break;
      }
    }
  }

  handleTransitionEnd = () => {
    const { message } = this.state;
    const transitionPage = document.getElementsByClassName('container');

    if (message === 'landscape') {
      return;
    }

    this.setMessage('sayHey');
    transitionPage[0].removeEventListener("transitionend", this.handleTransitionEnd);
  }

  handleSendEmail = emailState => {
    this.setState({ sendEmail: emailState });
  };

  handleResize = () => {
    const { isLoading } = this.state;

    if (!isLoading) {
      this.handleOrientationChange();
    }

    this.setState({ width: window.innerWidth });
  }

  handleScroll = e => {
    const { shouldAnim, charAttack, mobileDirection } = this.state;
    const target = e.currentTarget;

    if (isMobile) {
      if (mobileDirection === 'right') {
        if ((window.innerHeight + window.scrollY) <= document.body.offsetHeight) {
          target.scrollY += 150;
        }
      }

      if (mobileDirection === 'left') {
        if (this.prev > 0) {
          target.scrollY -= 150;
        }
      }
    }

    if (charAttack) {
      this.hideCharAttackButton();
    }

    if (this.prev > target.scrollY) {
      if (shouldAnim) {
        this.setState({ move: 'left' }, () => this.cantAnim());
      }
    } else if (this.prev < target.scrollY) {
      if (shouldAnim) {
        this.setState({ move: 'right' }, () => this.cantAnim());
      }
    }

    this.prev = target.scrollY;
    this.setState({ scrollPos: this.prev });
  };

  handleStartAttack = () => {
    const { startAttack } = this.state;
    let shouldExplode = false;

    if (startAttack) {
      shouldExplode = true;
    }

    this.setState(
      {
        startAttack: !startAttack,
        shouldExplode,
      },
      () => this.hideCharAttackButton(),
    );
  };

  handleCharMove = shouldMove => this.setState({ stopMove: !shouldMove });

  handStateEmail = state => {
    this.setState({ stateSendEmail: state });
  };

  handleResumeBottleAnim = () => {
    this.setState({ resumeBottleAnim: true });
  }

  handleLongClick = () => {
    this.moveRightMobile();
  }

  handleCallbackMessageHidden = () => {
    const { queueMessage } = this.state;

    if (queueMessage !== '') {
      this.setMessage(queueMessage);

      return;
    }

    this.removeMessage();
  }

  render() {
    const {
      scrollPos,
      move,
      charClass,
      blockScroll,
      isBlockScroll,
      sprite,
      spriteConfs,
      charAttack,
      startAttack,
      shouldExplode,
      stopMove,
      stateSendEmail,
      sendEmail,
      resumeBottleAnim,
      width,
      isLoading,
      isAssetsLoaded,
      message,
      blockScrollMobile,
      screenOrientation,
      spriteFrame,
    } = this.state;
    const florestSpeeds = ['slow', 'normal', 'fast', 'faster', 'superFaster'];
    const florestChooseClassSpeeds = ['slow', 'normal', 'fast', 'faster'];
    const caveSpeeds = ['slow', 'normal', 'fast'];
    const seaSpeeds = ['slow', 'normal', 'fast'];
    const islandSpeeds = ['slow', 'normal', 'fast'];
    const contactFormSpeeds = ['fast'];
    const groundSpeeds = ['fast'];

    return (
      <div>
        { isLoading ? (
          <Loading theme="white" />
        ) : null }
        <TransitionBackground loading={isLoading} />
        { !isAssetsLoaded ? null : (
          <RemoveScroll enabled={isMobile ? true : blockScroll}>
            <Helmet>
              <meta name="viewport" content="user-scalable=no" />
              <meta name="description" content="Mickael Neves - Front-End Developer from Portugal with an interactive resume." />
              <meta name="twitter:site" content="@MickaelNvs" />
              <meta name="twitter:creator" content="@MickaelNvs" />
              <meta name="twitter:title" content="Mickael Neves - Front-End Developer" />
              <meta name="twitter:card" content="Front-End Developer" />
              <meta property="og:title" content="Mickael Neves - Front-End Developer" />
              <meta property="og:url" content="https://www.mikemneves.com/" />
              <meta property="og:type" content="website" />
              <meta property="og:description" content="Front-End Developer" />
              <title>Mickael Neves</title>
            </Helmet>
            <div className="page" ref={this.page}>
              <div className={`container ${!isLoading ? 'loaded' : ''}`}>
                <UpdateLayerMovementSpeed
                  scrollPos={scrollPos}
                  speedTypes={florestSpeeds}
                >
                  <Florest />
                </UpdateLayerMovementSpeed>
                <UpdateLayerMovementSpeed
                  scrollPos={scrollPos}
                  speedTypes={florestChooseClassSpeeds}
                >
                  <FlorestChooseClass
                    changeClass={this.changeCharClassAnim}
                    blockScroll={this.blockScroll}
                  />
                </UpdateLayerMovementSpeed>
                <UpdateLayerMovementSpeed
                  scrollPos={scrollPos}
                  speedTypes={caveSpeeds}
                >
                  <Cave
                    showAttackButton={this.showCharAttackButton}
                    startAttack={startAttack}
                    handleStartAttack={this.handleStartAttack}
                    charClass={charClass}
                    shouldExplode={shouldExplode}
                    blockScroll={this.blockScroll}
                    isScrollBlocked={isBlockScroll}
                  />
                </UpdateLayerMovementSpeed>
                <UpdateLayerMovementSpeed
                  scrollPos={scrollPos}
                  speedTypes={seaSpeeds}
                >
                  <Sea
                    shouldCharMove={this.handleCharMove}
                    move={move}
                    width={width}
                  />
                </UpdateLayerMovementSpeed>
                <UpdateLayerMovementSpeed
                  scrollPos={scrollPos}
                  speedTypes={islandSpeeds}
                >
                  <Island
                    showAttackButton={this.showCharAttackButton}
                    startAttack={startAttack}
                    handleStartAttack={this.handleStartAttack}
                    charClass={charClass}
                    shouldExplode={shouldExplode}
                    changeStateEmail={this.handStateEmail}
                    resumeAnim={resumeBottleAnim}
                    attackButtonAtive={charAttack}
                  />
                </UpdateLayerMovementSpeed>
                <UpdateLayerMovementSpeed
                  scrollPos={scrollPos}
                  speedTypes={contactFormSpeeds}
                >
                  { stateSendEmail !== '' ? (
                    <ContactForm
                      changeStateEmail={this.handStateEmail}
                      sendEmail={sendEmail}
                      tryToSend={this.handleSendEmail}
                      resumeAnim={this.handleResumeBottleAnim}
                    />
                  ) : null }
                </UpdateLayerMovementSpeed>
                <UpdateLayerMovementSpeed
                  scrollPos={scrollPos}
                  speedTypes={groundSpeeds}
                >
                  <BottomLayer
                    ref={this.bottomLayer}
                    blockScroll={this.blockScroll}
                    canAnim={this.canAnim}
                    move={move}
                    charClass={charClass}
                    changeSprite={sprite}
                    changeSpriteConfs={spriteConfs}
                    charAttack={charAttack}
                    startAttack={this.handleStartAttack}
                    stopMove={stopMove}
                    sendEmail={sendEmail}
                    showMessage={message || stateSendEmail}
                    messageHidden={this.handleCallbackMessageHidden}
                    tryToSend={this.handleSendEmail}
                    characterIsLoaded={this.stopLoad}
                    freezeSpriteFrame={spriteFrame}
                  />
                </UpdateLayerMovementSpeed>
                { isMobile && !blockScrollMobile && screenOrientation === 'portrait' ? (
                  <div className="mobile-move-buttons">
                    <Repeatable
                      tag="div"
                      className="mobile-move-left"
                      onHold={() => this.setMobileDirection('left')}
                      onPress={() => this.setMobileDirection('left')}
                      repeatDelay={500}
                      repeatInterval={32}
                      repeatCount={0}
                    />
                    <Repeatable
                      tag="div"
                      className="mobile-move-right"
                      onHold={() => this.setMobileDirection('right')}
                      onPress={() => this.setMobileDirection('right')}
                      repeatDelay={500}
                      repeatInterval={32}
                      repeatCount={0}
                    />
                  </div>
                ) : null }
              </div>
            </div>
          </RemoveScroll>
        ) }
      </div>
    );
  }
}

export default AdventureWorld;
